import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import config from '../../config';
import { useSelector, useDispatch } from 'react-redux';
import { setBookingField, showTeamMenu, showTimeMenu, unitMenu } from '../../store/ResourceStore';
import unitBookImage from '../../images/book-udstyr-hojre.png';
import unitPlanImage from '../../images/planlaeg-udstyr-hojre copy.png';

const Unit = (props) => {
    const dispatch = useDispatch();

    const resState = useSelector((state) => state.resourceState);

    const unit = props.unit;
    if(!unit) return null;

    const currentBooking = props.currentBooking;
    const unitMenuId = resState.unitMenuId;
    const nextBooking = props.nextBooking;
    const nextBookStart = nextBooking ? moment(nextBooking.startTime) : false;
    const currentBookingEnd = currentBooking && moment(currentBooking.endTime);


    let text = 'Ingen fremtidig booking fundet';
    if(currentBooking) text = `Booket indtil: ${currentBookingEnd.format('LLLL')} (${currentBookingEnd.fromNow()})`;
    else if(nextBooking) text = `${nextBookStart.format('LLLL')} (${nextBookStart.fromNow()})`;

    const renderUnitMenu = () => {
        const now = moment();
        const nowPlus2 = moment();
        const endOfDay = moment();
        const todayMornig = moment();
        const todayEvening = moment();
        nowPlus2.add(2, 'hours');
        endOfDay.endOf('day');
        todayMornig.hour(7).minute(0);
        todayEvening.hour(15).minute(0);
        return(
            <div className='unit-menu'>
                <div className='unit-book' onClick={() => {
                    dispatch(setBookingField({ field: 'unitId', value: unitMenuId }));                    
                    dispatch(setBookingField({ field: 'startTime', value: now.toISOString()}));
                    dispatch(setBookingField({ field: 'endTime', value: endOfDay.toISOString()}));
                    dispatch(showTeamMenu(true));
                }}
                >
                    <img className='unit-book-image' src={unitBookImage} alt={''}/>
                    <div className='unit-book-text'>Book idag</div>

                </div>

                <div className='unit-plan' onClick={() => {
                    dispatch(setBookingField({ field: 'unitId', value: unitMenuId }));
                    dispatch(setBookingField({ field: 'startTime', value: todayMornig.toISOString() }));
                    dispatch(setBookingField({ field: 'endTime', value: todayEvening.toISOString() }));
                    dispatch(showTimeMenu(true));
                }}>
                    <img className='unit-plan-image' src={unitPlanImage} alt={''}/>
                    <div className='unit-plan-text'>Planlæg</div>
                </div>
            </div>
        )
    };

    return(
        <div className={`unit${currentBooking ? ' booked' : ''}`} onClick={() => dispatch(unitMenu({ unitId: unit.id, visible: unitMenuId !== unit.id }))}>            
            <img src={`${config.server}${unit.imagePath}`} alt=''/>
            <div className='unit-description'>
                {!props.hideName && <p className='unit-name'>{unit.name}</p>}
                {!props.hideText && <p>{text}</p>}
            </div>
            {!props.noMenu && unitMenuId === unit.id && renderUnitMenu()}
        </div>
    );
};


Unit.propTypes = {
    unit: PropTypes.object.isRequired,
    nextBooking: PropTypes.object,
    currentBooking: PropTypes.object,
    noMenu: PropTypes.bool,
    hideText: PropTypes.bool,
    hideName: PropTypes.bool
};

export default Unit;